export default __webpack_public_path__ + "static/media/file.c6125432.svg";